import React, { CSSProperties } from 'react';
import { Column, useTable, Row } from 'react-table';
import { ITablePropertyExtensions, IColumnPropertyExtensions } from 'types/components/react_table/IReactTablePropertyExtensions';
import { cnTbl, cnTblHead, cnTblHeadRow, cnTblHeadCell, cnTblHeadCellBold, cnTblHeadCellDense, cnTblBody, cnTblBodyRow, cnTblBodyRowAltColor, cnTblBodyCell, cnTblBodyCellDense, cnTblFoot, cnTblBodyRowClickable } from './TableStyleConstants';

const headCellClassName = `${cnTblHeadCell} ${cnTblHeadCellBold} ${cnTblHeadCellDense}`;
const bodyRowClassName = `${cnTblBodyRow} ${cnTblBodyRowAltColor}`;
const bodyCellClassName = `${cnTblBodyCell} ${cnTblBodyCellDense}`;

interface IProps {
	columns: Column<Object>[],
	data: Object[],
	rowTitle?: string,
	pageSize?: number,
	onRowClick?(): any,
	hasRowClick?: any,
	/** Possible footer that was passed */
	footer?: React.ReactNode,
	noDataMessage?: string,
	propertyExtensions?: ITablePropertyExtensions
}

function getColumnStyleExtensions(tablePropExtensions: ITablePropertyExtensions | undefined, accessor: string): IColumnPropertyExtensions | undefined {
	if (tablePropExtensions) {
		return tablePropExtensions.columnExtensions.find(ce => ce.accessor === accessor);
	} else {
		return undefined;
	}
}

function SimpleDataTable(props: IProps) {
	const {
		columns,
		data = [],
		onRowClick,
		hasRowClick,
	} = props;

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		rows,
		prepareRow
	} = useTable(
		{
			columns,
			data,
		}
	);

	return (
		<table {...getTableProps()} className={cnTbl}>
			<thead className={cnTblHead}>
				{headerGroups.map((headerGroup, hgIndex) => (
					<tr
						// key={hgIndex}
						{...headerGroup.getHeaderGroupProps()}
						className={cnTblHeadRow}
					>
						{headerGroup.headers.map((column, index) => {
							// console.log(column);
							let styles: CSSProperties = {};
							let columnStyleExtension = getColumnStyleExtensions(props.propertyExtensions, column.id);
							if (columnStyleExtension) {
								styles = columnStyleExtension.style;
							}

							return (
								<th
									// key={index}
									className={headCellClassName}
									{...column.getHeaderProps()} title=''
									style={styles}
								>
									<div>
										{column.render('Header')}
									</div>
								</th>
							)
						})}
					</tr>
				))}
			</thead>
			<tbody {...getTableBodyProps()} className={cnTblBody}>
				{rows.map((row: Row<Object>, rowIndex: number) => {
					prepareRow(row);
					const classExtension = hasRowClick ? cnTblBodyRowClickable : ''
					return <tr 
						// key={rowIndex}
						{...row.getRowProps()}
						// className={'tb__row--clickable'}
						// className={bodyRowClassName}
						className={`${bodyRowClassName} ${classExtension}`}

						title={props.rowTitle}
						//@ts-ignore
						onClick={()=>onRowClick(row)}
						>
						{row.cells.map((cell, cellIndex) => {
							let cellStylings: React.CSSProperties = {};
							if (cell.column.minWidth) cellStylings.minWidth = cell.column.minWidth;
							if (cell.column.maxWidth) cellStylings.maxWidth = cell.column.maxWidth;
							if (cell.column.width) cellStylings.width = cell.column.width;

							let columnStyleExtension = getColumnStyleExtensions(props.propertyExtensions, cell.column.id);
							if (columnStyleExtension) {
								cellStylings = { ...cellStylings, ...columnStyleExtension.style };
								// console.log('cellStylings', cellStylings);
							}

							return (
								<td 
									// key={cellIndex}
									{...cell.getCellProps()}
									style={cellStylings}
									className={bodyCellClassName}
								>
									{cell.render('Cell')}
								</td>
							)
						})}
					</tr>
				})}
			</tbody>
			{props.footer &&
				<tfoot className={cnTblFoot}>
					{props.footer}
				</tfoot>
			}
		</table>
	);
};

export default SimpleDataTable;